import React, { useEffect } from "react";
import styles from "./Card.module.css";
import { FaArrowRight } from "react-icons/fa6";

const JobCard = ({ jobName, experience, onClick, selectedJob, index, job }) => {
  // Check if application deadline has passed
  const isDeadlinePassed = job?.deadline
    ? new Date(job.deadline) < new Date()
    : false;

  return (
    <div className={styles.cardcontainer} onClick={onClick}>
      <h5 className={styles.jobName}>{jobName}</h5>
      <h5 className={styles.experience}>{experience}</h5>
      {isDeadlinePassed && (
        <div className={styles.closedBadge}>Application Closed</div>
      )}
      <FaArrowRight className={styles.arrow} />
    </div>
  );
};

export default JobCard;
